export default __webpack_public_path__ + "static/media/subLogo.559d8338.svg";